// Haptics — thin wrapper around Capacitor's Haptics plugin. No-ops on
// web / Android so callers don't need to conditionally check platform.
//
// Style guide:
//   • hapticLight()  — plan card tap, quiz option tap, toggle
//   • hapticMedium() — primary CTAs (buy, start quiz, save meal)
//   • hapticSuccess() — purchase success, meal logged, streak advanced
//   • hapticError()   — purchase failed, validation error

import { isNativeApp } from "@/lib/native";

let _plugin = null;
async function getPlugin() {
  if (_plugin) return _plugin;
  if (!isNativeApp()) return null;
  try {
    const mod = await import("@capacitor/haptics");
    _plugin = mod;
    return mod;
  } catch (_) {
    return null;
  }
}

export async function hapticLight() {
  const m = await getPlugin();
  m?.Haptics?.impact({ style: m.ImpactStyle?.Light }).catch(() => {});
}

export async function hapticMedium() {
  const m = await getPlugin();
  m?.Haptics?.impact({ style: m.ImpactStyle?.Medium }).catch(() => {});
}

export async function hapticSuccess() {
  const m = await getPlugin();
  m?.Haptics?.notification({ type: m.NotificationType?.Success }).catch(() => {});
}

export async function hapticError() {
  const m = await getPlugin();
  m?.Haptics?.notification({ type: m.NotificationType?.Error }).catch(() => {});
}
